const WORKFLOW_MANAGER_ROLES = new Set([
  'founder',
  'director',
  'admin',
  'hr head',
  'hr admin',
  'manager',
]);

export const normalizeWorkflowRole = (role?: string | null): string =>
  (role || 'employee').trim().toLowerCase();

export const canManageWorkflow = (role?: string | null): boolean =>
  WORKFLOW_MANAGER_ROLES.has(normalizeWorkflowRole(role));

export const canViewWorkflowActivity = (_role?: string | null): boolean => true;
